import { IHeaderCommandBarItem } from "azure-devops-ui/HeaderCommandBar";
import { MenuItemType } from "azure-devops-ui/Menu";

export const commandBarItemsSimple: IHeaderCommandBarItem[] = [
    {
        iconProps: {
            iconName: "Add"
        },
        id: "testCreate",
        important: true,
        onActivate: () => {
            alert("This would normally trigger a modal popup");
        },
        text: "Action",
        tooltipProps: {
            text: "Custom tooltip for create"
        },

    },
    {
        iconProps: {
            iconName: "Delete"
        },
        id: "testDelete",
        important: false,
        onActivate: () => {
            alert("submenu clicked");
        },
        text: "Menu row with delete icon"
    },
    {
        iconProps: {
            iconName: "Share"
        },
        id: "testShare",
        important: false,
        onActivate: () => {
            alert("submenu clicked");
        },
        text: "Menu row with share icon"
    }
];

export const commandBarItemsAdvanced: IHeaderCommandBarItem[] = [
    {
        iconProps: {
            iconName: "Download"
        },
        id: "testSave",
        important: true,
        onActivate: () => {
            alert("Example text");
        },
        text: "Download"
    },
    {
        iconProps: {
            iconName: "Share"
        },
        id: "testShare",
        onActivate: () => {
            alert("Example text");
        },
        text: "Share"
    },
    {
        iconProps: {
            iconName: "Add"
        },
        id: "testCreate",
        important: true,
        isPrimary: true,
        onActivate: () => {
            alert("This would normally trigger a modal popup");
        },
        text: "Add"
    },
    {
        iconProps: {
            iconName: "FavoriteStar"
        },
        id: "testCreate",
        important: false,
        onActivate: () => {
            alert("This would normally trigger a modal popup");
        },
        text: "Add to favorites"
    },
    {
        iconProps: {
            iconName: "CheckMark"
        },
        id: "testCreate",
        important: false,
        onActivate: () => {
            alert("This would normally trigger a modal popup");
        },
        text: "Approve item"
    },
    { id: "separator", itemType: MenuItemType.Divider },
    {
        iconProps: {
            iconName: "Delete"
        },
        id: "testDelete",
        onActivate: () => {
            alert("Example text");
        },
        text: "Delete",
    }
];
